/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type UserInfo } from '@coze-foundation/account-base';

import { UC_BFF_PATHS } from './uc-bff-paths';
import { cozeUcBffGet, cozeUcBffPost } from './uc-bff';
import type { UcDeptTreeNode } from './department';

export function getLoginAccountInfo() {
  return cozeUcBffGet<Record<string, unknown>>(UC_BFF_PATHS.loginAccountInfo);
}

export function fetchDepartmentTreeV2() {
  return cozeUcBffGet<UcDeptTreeNode[]>(UC_BFF_PATHS.departmentTreeV2);
}

export interface UcLoginPassportBody {
  data: UserInfo;
  code?: number;
  msg?: string;
  uc_userkey?: string;
  uc_tenant_id?: string;
}

export function postUcLoginViaBff(params: {
  account: string;
  password: string;
}) {
  return cozeUcBffPost<UcLoginPassportBody>(UC_BFF_PATHS.login, {
    account: params.account.trim(),
    password: params.password.trim(),
  });
}

export function postUcBridgeViaBff() {
  return cozeUcBffPost<UcLoginPassportBody>(UC_BFF_PATHS.bridge, {});
}
